module.exports = __webpack_public_path__ + "img/HNYT087_18.0e7894f1.gif";